import React from 'react';
import styled from 'styled-components';
import {
  Accordion,
  AccordionItem,
  AccordionMode,
} from '@hotelplan/components.common.accordion';
import { FdrTitleText } from '@hotelplan/supergraph-api';
import { TextContainer } from './information-section/fdr-geo-information-section.styles';
import { NavigationIds } from './navigation/fdr-geo-navigation.types';

interface IGeoBestTravelPeriodProps {
  title?: string;
  text?: string;
  accordion?: FdrTitleText[];
}

const AccordionTextWrapper = styled.div(
  ({ theme }) => theme.text.richText,
  ({ theme: { space } }) => ({
    padding: space[3],
  })
);

const BestTravelPeriodAccordionWrapper = styled.div(({ theme: { space } }) => ({
  paddingTop: space[3],
  '.accordionButtonWrap': {
    padding: 0,
  },
  '.accordionButton': {
    paddingLeft: space[3],
    paddingRight: space[3],
    fontWeight: 450,
  },
}));

const BestTravelPeriodTitle = styled.h2.attrs({
  className: 'lead-title',
})(({ theme: { space } }) => ({
  paddingBottom: space[6],
}));

const BestTravelPeriodText = styled.div(({ theme: { fontSizes } }) => ({
  p: {
    fontSize: fontSizes[3],
  },
}));

const BestTravelPeriodAccordionButton = styled.h3(
  ({ theme: { fontSizes, space } }) => ({
    borderTop: '1px solid',
    borderBottom: '1px solid',
    marginBottom: '-1px !important',
    transition: 'none',
    fontSize: `${fontSizes[3]} !important`,
    padding: space[3],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    lineHeight: '26px',
    letterSpacing: '0.7px',
  })
);

const FdrGeoBestTravelPeriod: React.FC<IGeoBestTravelPeriodProps> = ({
  title,
  text,
  accordion,
}) => {
  return (
    <TextContainer id={NavigationIds.BEST_TRAVEL_PERIOD}>
      <div className="lead-text-wrapper">
        {title && <BestTravelPeriodTitle>{title}</BestTravelPeriodTitle>}
        {text && (
          <BestTravelPeriodText dangerouslySetInnerHTML={{ __html: text }} />
        )}
        {accordion?.length > 0 && (
          <BestTravelPeriodAccordionWrapper>
            <Accordion mode={AccordionMode.MULTIPLE}>
              {accordion
                .filter(
                  item => item?.title?.length > 0 && item?.text?.length > 0
                )
                .map((item, index) => {
                  return (
                    <AccordionItem
                      key={`${item.title}-${index}`}
                      title={item.title}
                      AccordionButtonComponent={BestTravelPeriodAccordionButton}
                    >
                      <AccordionTextWrapper
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      />
                    </AccordionItem>
                  );
                })}
            </Accordion>
          </BestTravelPeriodAccordionWrapper>
        )}
      </div>
    </TextContainer>
  );
};

export default FdrGeoBestTravelPeriod;
